import React from 'react';
import { AnimatedElement } from '../../animated-element';
import {
  Container, Wrapper, IntroLine, Headline,
} from '../styles/cta-promo.style';
import { BlueButton, BlueButtonExternal } from '../../../utils/atoms';

/**
 * Determines if the lunk is internal external
 * @param {object} param0 incoming props
 * @returns {XML} An outgoing link
 */
const ctaLinkRender = ({ ctaLink, ctaDisplayText }) => {
  if (ctaLink && ctaLink.match(/^https?:/i)) {
    return (
      <BlueButtonExternal href={ctaLink} label={ctaDisplayText} target="blank">
        <span>{ctaDisplayText}</span>
      </BlueButtonExternal>
    );
  }
  return (
    <BlueButton to={ctaLink} label={ctaDisplayText}>
      <span>{ctaDisplayText}</span>
    </BlueButton>
  );
};

/**
 * CTAPromo Component
 * @param {object} props Incoming props
 * @returns {XML} React Component
 */
const CTAPromo = ({
  title, description, ctaLink, ctaDisplayText, backgroundImage, longDescription,
}) => {
  let text = description;
  if (longDescription && longDescription.childMarkdownRemark && longDescription.childMarkdownRemark.html) {
    text = longDescription.childMarkdownRemark.html;
  }
  return (
    <AnimatedElement
      data={{ image: { file: { url: backgroundImage && backgroundImage.file ? backgroundImage.file.url : '' } } }}
      animationType="PARALLAX"
    >
      <Container>
        <Wrapper>
          <IntroLine>
            <span className="text">{title}</span>
          </IntroLine>
          <Headline dangerouslySetInnerHTML={{ __html: text }} />
          {ctaLink && ctaDisplayText ? ctaLinkRender({ ctaLink, ctaDisplayText }) : null}
        </Wrapper>
      </Container>
    </AnimatedElement>
  );
};

export default CTAPromo;



// WEBPACK FOOTER //
// ./src/components/cta-promo/components/cta-promo.js